import { TAccountType } from "@/api/v1_0";
import { Loader } from "@/components/Loader";
import { FunctionComponent, ReactElement } from "react";
import {
  Debt,
  ExpenseCategory,
  Goal,
  IncomeSource,
  Saving,
} from "./_dependencies";
import { IOverviewProps } from "./types";

export const Overview: FunctionComponent<IOverviewProps> = (
  props: IOverviewProps
): ReactElement<IOverviewProps> | null => {
  const { account, ...restProps } = props;

  switch (account.type) {
    case TAccountType.Debt:
      return <Debt debt={account} {...restProps} />;
    case TAccountType.ExpenseCategory:
      return <ExpenseCategory expenseCategory={account} {...restProps} />;
    case TAccountType.Goal:
      return <Goal goal={account} {...restProps} />;
    case TAccountType.IncomeSource:
      return <IncomeSource incomeSource={account} {...restProps} />;
    case TAccountType.Saving:
      return <Saving saving={account} {...restProps} />;
    default:
      return <Loader />;
  }
};
